import React from 'react'
import styled from '@emotion/styled'

type LabeledItemProps<T = {}> =
    T & {
        children?: React.ReactNode
        title: string
    }

const Content = styled.div`
    display: flex;
    justify-items: left;
    align-items: center;
    width: auto;
    padding-bottom: 0.5rem;
`

const Label = styled.div`
    font-weight: bold;
`

export function LabeledItem({ title, children }: LabeledItemProps) {
    return <Content>
        <Label>{title}</Label>
        {children}
    </Content>
}
